module.exports = __webpack_public_path__ + "img/if_3.cc8fd0a1.png";